const getReduce = (action, state) => {
  return {
    ...state,
    ...{
      [action.key]: {
        ...state[action.key],
        result: action.payload.data,
        pagingInfo: action.payload.pagingInfo,
      },
    },
  };
};

const loadingReduce = (action, state) => {
  const newState = { ...state };
  newState[action.payload.subject]["loading"] = action.payload.active;
  return newState;
};

const setFilter = (action, state) => {
  const newState = { ...state, [action.key]: action.payload };
  return newState;
};

const setPath = (action, state) => {
  const newState = { ...state, currentPath: action.payload };
  return newState;
};

export default (state, action) => {
  let _state = {
    loading: () => loadingReduce(action, state),
    list: () => getReduce(action, state),
    filter: () => setFilter(action, state),
    new: () => setFilter(action, state),
    currentPath: () => setPath(action, state)
  };

  return _state[action.action]();
};
